import {
  AudioRecordingModelData,
  AudioRecordingUploadStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkErrorUploadingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_ERROR_UPLOADING_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    // COMPLETED/SKIPPED are terminal states.
    if (
      existingData.upload_status === AudioRecordingUploadStatus.COMPLETED ||
      existingData.upload_status === AudioRecordingUploadStatus.SKIPPED
    ) {
      return {};
    }

    return {
      upload_status: AudioRecordingUploadStatus.ERROR,
    };
  }
}
